const indexItems = [
  { label: '国产古装', icon: 'ri-building-2-line', desc: '仙侠、宫廷、武侠精选' },
  { label: '国产现代', icon: 'ri-store-2-line', desc: '都市、职场、家庭剧场' },
  { label: '悬疑探案', icon: 'ri-search-eye-line', desc: '烧脑、推理、刑侦佳作' },
  { label: '韩剧专区', icon: 'ri-earth-line', desc: '爱情、奇幻、现实题材' },
  { label: '美剧精选', icon: 'ri-global-line', desc: '科幻、剧情、高分系列' },
  { label: '青春甜宠', icon: 'ri-heart-line', desc: '校园、恋爱、轻松治愈' },
  { label: '经典重温', icon: 'ri-time-line', desc: '口碑老剧、年代经典' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">剧集索引</h2>
          <p className="mt-2 text-sm text-foreground-500">按分类快速找到你想看的剧</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.label}
              className="bg-background-100 rounded-xl p-5 text-center hover:bg-accent-50 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-background-200 text-accent-600 group-hover:bg-accent-100 group-hover:text-accent-700 transition-colors mb-3">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">{item.label}</h3>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}